import { type TabId } from "../components/tabs";

export const TAB_RANKING: TabId[] = ["breakdown", "campaign", "adset", "ad"];
export const TAB_RANKINGS = {
  breakdown: 1,
  campaign: 2,
  adset: 3,
  ad: 4,
};
